// src/components/Sidebar.js
import { NavLink } from 'react-router-dom';
import { Home, Folder, Users, MessageSquare, Target,Work} from 'lucide-react';
import { RiSurveyLine } from "react-icons/ri";
import clsx from 'clsx';

const navItems = [
  { path: '/', label: 'Home', icon: Home },
  { path: '/project', label: 'Project', icon: Folder },
  { path: '/jobinformations', label: 'Job', icon: RiSurveyLine },
  { path: '/resource', label: 'Resource', icon: Users },
  { path: '/feedback', label: 'Feedback', icon: MessageSquare },
  
  
];

const Sidebar = ({ collapsed }) => {
  return (
    <aside
      className={clsx(
        'bg-white dark:bg-gray-900 shadow-md h-screen border-r border-gray-200 dark:border-gray-800 transition-all duration-300 ease-in-out',
        collapsed ? 'w-16' : 'w-[10.2rem]'
      )}
    >
      <nav className="p-4 flex flex-col gap-2">
        {navItems.map(({ path, label, icon: Icon }) => (
          <NavLink
            key={path}
            to={path}
            className={({ isActive }) =>
              clsx(
                'flex items-center gap-3 p-2 rounded-md transition hover:bg-gray-100 dark:hover:bg-gray-800',
                {
                  'bg-gray-200 dark:bg-red-800 text-gray-700 dark:text-white font-semibold': isActive,
                }
              )
            }
          >
            {/* Icon wrapper with fixed size to avoid stretching */}
            <span className="w-5 h-5 flex items-center justify-center text-gray-600 dark:text-gray-300">
              <Icon size={20} />
            </span>
            {!collapsed && <span className="whitespace-nowrap">{label}</span>}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
